import ANALYTICS from 'constants/analytics.json';
import { ADOBE_URL, BASICUSERS } from 'constants/constant';
import { getCurrentEnv } from './utils';
import { getFullPersona } from './helper';
import { INTERNAL } from 'constants/constant';
import { PERSONA } from 'constants/constant';

export const loadAdobeScript = () => {
	const env = getCurrentEnv();
	window.__DATAVENTURES_PORTAL__.dataLayer.appName = `${env}ReportBuilder`;

	const adobeScriptURL = env === 'prod' ? ADOBE_URL['prod'] : ADOBE_URL['non-prod'];

	loadScriptFile(adobeScriptURL, document.getElementsByTagName('head')[0], true, true);
};

const loadScriptFile = (file, appendTo, async, defer) => {
	const script = document.createElement('script');

	script.src = file;

	if (async) {
		script.async = true;
	}

	if (defer) {
		script.defer = true;
	}

	appendTo?.appendChild(script);
};

export const loadContent = (appendTo) => {
	const script = document.createElement('script');

	script.type = 'text/javascript';

	appendTo?.appendChild(script);
};

export const trackPageInfo = (pageName) => {
	if (window.__DATAVENTURES_PORTAL__?.dataLayer && ANALYTICS[pageName]) {
		window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
			{},
			window.__DATAVENTURES_PORTAL__.dataLayer,
			{
				page: ANALYTICS[pageName]
			}
		);
		triggerEvent('pageNavigation');
	}
};

export const trackLoggedInUserInfo = ({ companyName, userType, catManUser, companyType }) => {
	if (
		(window.__DATAVENTURES_PORTAL__?.dataLayer?.userDetails &&
			Object.entries(window.__DATAVENTURES_PORTAL__.dataLayer.userDetails).length === 0) ||
		(window.__DATAVENTURES_PORTAL__?.dataLayer &&
			!window.__DATAVENTURES_PORTAL__.dataLayer.userDetails)
	) {
		const companyDetail =
			(Array.isArray(companyName) && companyName.map((list) => list.companyName).join(', ')) ||
			(companyName && companyName) ||
			'';
		const userKind = (userType && userType) || INTERNAL;
		let userRole = '';
		if (userKind === INTERNAL) {
			userRole = getFullPersona(PERSONA.MERCHANT);
		} else {
			userRole = catManUser ? getFullPersona(PERSONA.CATMAN) : getFullPersona(PERSONA.STANDARD);
		}
		// Track the basic user by userRole
		if (companyType && BASICUSERS.includes(companyType)) {
			userRole = `BASIC_${userRole}`;
		}

		window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
			{},
			window.__DATAVENTURES_PORTAL__.dataLayer,
			{
				userDetails: {
					companyName: companyDetail,
					userType: userKind,
					userRole: userRole
				}
			}
		);
		triggerEvent(`logUserInfo`);
	}
};

export const trackEventInfo = ({ type, actionOn, location }) => {
	window.__DATAVENTURES_PORTAL__.dataLayer = Object.assign(
		{},
		window.__DATAVENTURES_PORTAL__.dataLayer,
		{
			[type]: actionOn,
			location: ANALYTICS[location] ? ANALYTICS[location].name : location
		}
	);
	triggerEvent(`${type}Event`);
};

const triggerEvent = (type) => {
	window.__DATAVENTURES_PORTAL__?.dataLayer?.analyticsEvent?.push({ type: type });
};
